export default "__VITE_ASSET__DE13noOI__"